import { render, staticRenderFns } from "./Like.vue?vue&type=template&id=65a5ace6&lang=pug"
import script from "./Like.vue?vue&type=script&lang=js"
export * from "./Like.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports